// src/services/avaliacaoService.js

import api from './api';

/**
 * Lista todas as avaliações (caso seja necessário exibir em alguma tela).
 */
export const listarAvaliacoes = async () => {
  return api.get('/avaliacoes');
};
export const buscarAvaliacaoPorDefesa = async (defesaId) => {
    try {
      const response = await api.get(`/avaliacoes/defesa/${defesaId}`);
      return response.data;
    } catch (error) {
      if (error.response?.status === 404) {
        return null;
      }
      throw error;
    }
  };
/**
 * Obtém detalhes de uma avaliação específica.
 * @param {number|string} id 
 * @returns {Promise<AxiosResponse<any>>}
 */
export const obterAvaliacao = async (id) => {
  return api.get(`/avaliacoes/${id}`);
};

/**
 * Cria uma nova avaliação.
 * @param {Object} avaliacao 
 * @returns {Promise<AxiosResponse<any>>}
 */
export const criarAvaliacao = async (avaliacao) => {
  return api.post('/avaliacoes', avaliacao);
};

/**
 * Atualiza uma avaliação existente.
 * @param {number|string} id 
 * @param {Object} avaliacao 
 * @returns {Promise<AxiosResponse<any>>}
 */
export const atualizarAvaliacao = async (id, avaliacao) => {
  return api.put(`/avaliacoes/${id}`, avaliacao);
};

/**
 * Exclui uma avaliação pelo ID.
 * @param {number|string} id 
 * @returns {Promise<AxiosResponse<any>>}
 */
export const excluirAvaliacao = async (id) => {
  return api.delete(`/avaliacoes/${id}`);
};

/**
 * Lista somente as avaliações "pendentes" para o usuário logado 
 * (o backend identifica o tipo de usuário pelo token).
 */
export const listarAvaliacoesPendentes = async () => {
  try {
    // Chama a rota /avaliacoes/pendentes (SEM :userRole)
    const response = await api.get('/avaliacoes/pendentes');
    return response;
  } catch (error) {
    console.error('Erro ao buscar avaliações pendentes:', error);
    throw error;
  }
};

const avaliacaoService = {
  listarAvaliacoes,
  obterAvaliacao,
  criarAvaliacao,
  atualizarAvaliacao,
  excluirAvaliacao,
  listarAvaliacoesPendentes
};

export default avaliacaoService;
